import { useRecoilValue } from "recoil";

import { useFeatureGates } from "../../cof-feature-gates/hooks";
import { defaultOrganizationContainerSelector } from "../../core/recoil/organizations";
import { CofConfigId } from "../../gql-generated/types";

import { useOrganizationsV2 } from "./useOrganizationsV2";

export const useDefaultOrganizationId = (): string => {
    const { configs } = useFeatureGates();
    const isMyLensesOrgsV2Enabled = configs[CofConfigId.MyLensesOrgsV2].enabled;
    const defaultOrgV1 = useRecoilValue(defaultOrganizationContainerSelector);
    const { defaultOrganizationContainer: defaultOrgV2 } = useOrganizationsV2();

    return (isMyLensesOrgsV2Enabled ? defaultOrgV2?.id : defaultOrgV1?.id) ?? "";
};
